import { Form, Formik } from "formik";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef
} from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  getInitialValuesAdd,
  getInitialValuesEditOrView,
  ValidationSchema
} from "./validation";
import Title_Section from "../../../components/Title_Section/Title_Section";
import { ROUTE_PATHS } from "../../../utils/PathsNames";
import Input from "../../../components/Input/index";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../components/Select";
import { formatOptions } from "../../../utils/Helpers";
import { getBooksRequest } from "../../../store/Books/actions";
import Button from "../../../components/Button/index";
import {
  addNewPackageRequest,
  editPackageRequest,
  getSinglePackageRequest
} from "../../../store/Packages/actions";
import Upload from "../../../components/Upload";
// import CancelIcon from "@mui/icons-material/Cancel";
import styles from "./PackageFormAVE.module.scss";
import MaterialPreview from "../../../components/MaterialPreview";
import { uploadToS3 } from "../../../utils/S3";
import { showHideLoader } from "../../../store/Loader/actions";
import { showHideSnackbar } from "../../../store/Snackbar/actions";
import messages from "../../../assets/locale/messages";

const VALID_MODES = ["Add", "Edit", "View"];

function PackageFormAVE() {
  const uploadRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const { mode, id } = useParams();
  const booksList = useSelector((state) => state.books.list);

  const singlePackage = useSelector(
    (state) => state.packagesReducer.package
  );
  const lang = useSelector((state) => state.locale.lang);

  const {
    package: {
      addTitle,
      editTitle,
      viewTitle,
      labels: {
        packageName,
        packagePrice,
        packageImage,
        packageBooks,
        packageDescription
      }
    },
    buttons: { submit }
  } = messages[lang];

  useEffect(() => {
    dispatch(getBooksRequest({ for_students: true }));

    if (id) dispatch(getSinglePackageRequest(id));
  }, []);
  useEffect(() => {
    if (!VALID_MODES.includes(mode)) {
      history.push(`${ROUTE_PATHS.notFound}`);
    }
  }, [mode, id, history]);
  async function handleSubmit(values) {
    try {
      dispatch(showHideLoader(true));

      if (mode === "Add") {
        if (values?.image_url instanceof File) {
          const { link } = await uploadToS3(
            "public",
            values?.image_url,
            values?.image_url?.name
          );
          values.image_url = link;
        }
        dispatch(addNewPackageRequest({ package: values }));
      } else if (mode === "Edit") {
        if (values?.image_url instanceof File) {
          const { link } = await uploadToS3(
            "public",
            values?.image_url,
            values?.image_url?.name
          );
          values.image_url = link;
        }
        dispatch(
          editPackageRequest({ package: values, id: Number(id) })
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  function handleDeleteImage(setFieldValue) {
    setFieldValue("image_url", "");
    if (uploadRef?.current) {
      uploadRef.current.value = "";
    }
  }
  const imageValidation = useCallback((src) => {
    if (src instanceof File) {
      if (src?.type?.includes("image")) {
        return URL.createObjectURL(src);
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    } else if (typeof src === "string") {
      return src;
    }
    return null;
  }, []);

  return (
    <>
      <Title_Section
        title={
          mode === "Add"
            ? addTitle
            : mode === "Edit"
            ? editTitle
            : viewTitle
        }
        className={"mb-4"}
      />
      <Formik
        onSubmit={handleSubmit}
        enableReinitialize
        validationSchema={ValidationSchema()}
        initialValues={
          mode !== "Add"
            ? getInitialValuesEditOrView(singlePackage)
            : getInitialValuesAdd()
        }
      >
        {({ values, setFieldValue }) => {
          const imgSrc = useMemo(
            () => imageValidation(values?.image_url),
            [values?.image_url]
          );
          return (
            <Form>
              <div className={styles.UploadContainer}>
                {mode !== "View" && (
                  <Upload
                    accept="image/*"
                    name="image_url"
                    label={packageImage}
                    setFieldValue={setFieldValue}
                    ref={uploadRef}
                    isRequired={true}
                    disabled={mode === "View"}
                  />
                )}
                <div className={styles.previewContainer}>
                  <MaterialPreview
                    type={1}
                    isPublic={true}
                    src={imgSrc}
                    hasClear={mode !== "View" ? true : false}
                    onClear={() => handleDeleteImage(setFieldValue)}
                  />
                </div>
              </div>
              <Input
                name="name"
                isRequired={true}
                isDisabled={mode === "View"}
                label={packageName}
              />
              <Input
                inputShape="textarea"
                showCounter={true}
                charLimit={800}
                name="description"
                isDisabled={mode === "View"}
                label={packageDescription}
                isRequired={true}
                type="text"
              />
              <Input
                name="price"
                isRequired={true}
                isNumber={true}
                isDisabled={mode === "View"}
                type={"number"}
                label={packagePrice}
              />
              <CustomSelect
                options={booksList.map((book) =>
                  formatOptions(book, "id", "title")
                )}
                placeholder={packageBooks}
                disabled={mode === "View"}
                name="book_ids"
                isSearchable={true}
                isMulti={true}
                isRequired={true}
                isAddNoneOption={false}
              />
              {mode !== "View" && (
                <Button text={submit} type="submit" />
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default PackageFormAVE;
